// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1XF_Y","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__SqbS7"};